<template>
<div>
  <gmap-map
    :center="getPosition"
    map-type-id="terrain"
    :options="mapOptions"
    style="width: 100%; height: 372px"
    :zoom="13"
  >
    <gmap-marker  :position="getPosition" :icon="getMarker"></gmap-marker>
    <div v-for="(area, index) in getAreaDelivery" :key="index">
      <gmap-polygon v-if="area.type=='shape'" 
      :path="area.vertices.path"
      :options="area.vertices"
       ></gmap-polygon>
      <gmap-circle v-else-if="area.type=='circle'" :path="area.vertices.path"
      :center="area.circle.center"
      :radius="area.circle.radius"
      :options="area.circle"
       ></gmap-circle>
    </div>
  </gmap-map>
    <el-divider v-if="getAreaDelivery.length"></el-divider>
    <div class="box-widget-item fl-wrap" v-if="getAreaDelivery.length">
      <div class="box-widget-item-header">
        <h3>{{ $t('text.delivery_details') }} :</h3>
      </div>
      <div class="box-widget delivery-details">
        <div class="box-widget-content">
         <span class="title-icon">
            <i class="k-icon-cab"></i> {{ $t("text.available_delivery_areas") }}</span>
          <ul v-for="(area, index) in getAreaDelivery" :key="index">
            <li>
              <span class="dot large" :style="[{'background-color':area.colour}]"></span>
              <span class="area-name">{{area.name}}</span>
              <span class="area-condition"><span v-for="(condition,idx) in area.conditions" :key="idx">{{getCondition(condition)}}</span></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import Vue from 'vue';
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
      load: {
        key: "AIzaSyCkzQwU1B_o8vKBzZzCs2u7SCPvc9CZCNM",
        libraries: "places" // This is required if you use the Autocomplete plugin
      }
    });
export default {
  name:'map-viewer',
  data() {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  },
  computed:{
    getMarker(){
        return './img/marker.png'
    },
    getPosition(){
      return {lat:parseFloat(this.selectedLocation.address.lat),lng:parseFloat(this.selectedLocation.address.lng) }
    },
    getAreaDelivery(){
      return this.selectedLocation.allDeliveryAreas;
    },
  },
  methods : {
    getCondition(condition){
      return `${this.$options.filters.currency(condition.charge)} ${condition.condition} ${this.$options.filters.currency(condition.total)}`
    }
  }
};
</script>
